






import Vue from 'vue'

export default Vue.extend({
  name: 'Button',
  props: {
    click: Function,
    outlined: Boolean,
    href: String,
    target: String
  },
  methods: {
    handleClick(event: HTMLElement) {
      if (this.href) window.open(this.href, this.target || '_blank')
      if (this.click) this.click(event)
    }
  }
})
